import React from "react";
import { Link } from "react-router-dom";
const FooterWeb = () => {
  return (
    <div className="footerAsiaFront">
      <p>Copyright © 2025 <Link to="/"> Asia Direct - Africa</Link> rights reserved</p>
    </div>
  );
};

export default FooterWeb;
